<template>
  <div class="type-tables">
    <a-card title="任务类型说明">
      <div class="table-filters">
        <a-input v-model:value="styleFilters.id" placeholder="筛选 StyleID" aria-label="筛选 StyleID" allow-clear />
        <a-input v-model:value="styleFilters.name" placeholder="筛选 StyleName" aria-label="筛选 StyleName" allow-clear />
      </div>
      <a-table :columns="columns" :data-source="filteredStyles" row-key="key" :pagination="false">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'disabled'">
            <a-tag :color="record.disabled ? 'red' : 'green'">{{ record.disabled ? '是' : '否' }}</a-tag>
          </template>
        </template>
      </a-table>
    </a-card>
    <a-card title="工具类型说明">
      <div class="table-filters">
        <a-input v-model:value="toolFilters.id" placeholder="筛选 toolID" aria-label="筛选 toolID" allow-clear />
        <a-input v-model:value="toolFilters.name" placeholder="筛选 toolName" aria-label="筛选 toolName" allow-clear />
      </div>
      <a-table :columns="toolColumns" :data-source="filteredTools" row-key="value" :pagination="false" />
    </a-card>
  </div>
</template>

<script>
import { computed, defineComponent, reactive } from 'vue'
import { TaskStyleGroupOptions, ToolIDOptions } from '@/utils/macro'

export default defineComponent({
  setup() {
    const columns = [
      { title: 'StyleID', dataIndex: 'value', key: 'value' },
      { title: 'StyleName', dataIndex: 'label', key: 'label' },
      { title: '是否下线', dataIndex: 'disabled', key: 'disabled', width: 120 },
    ]
    const dataSource = TaskStyleGroupOptions.flatMap((group, groupIndex) =>
      group.options.map((item, itemIndex) => ({
        ...item,
        key: `${groupIndex}-${itemIndex}`,
      }))
    )
    const toolColumns = [
      { title: 'toolID', dataIndex: 'value', key: 'value' },
      { title: 'toolName', dataIndex: 'label', key: 'label' },
    ]
    const toolDataSource = ToolIDOptions.filter(item => item.value != null && String(item.value).trim() !== '')
    const styleFilters = reactive({ id: '', name: '' })
    const toolFilters = reactive({ id: '', name: '' })
    const matches = (value, keyword) => String(value ?? '').toLowerCase().includes(keyword.trim().toLowerCase())
    const filterRows = (rows, filters) => rows.filter(item =>
      matches(item.value, filters.id) && matches(item.label, filters.name)
    )
    const filteredStyles = computed(() => filterRows(dataSource, styleFilters))
    const filteredTools = computed(() => filterRows(toolDataSource, toolFilters))
    return { columns, toolColumns, styleFilters, toolFilters, filteredStyles, filteredTools }
  },
})
</script>

<style scoped>
.type-tables {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

@media (max-width: 768px) {
  .type-tables {
    grid-template-columns: 1fr;
  }
}

.table-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}
</style>
